import Sidebar from "../../components/sidebar/Sidebar";
import React from "react";
import MainSection from "../../components/mainLayout/Main";
import SectionHeader from "../../components/sectionHeader/SectionHeader";
import DatatableSection from "../../components/datatableSection/DatatableSection";
import TaskManagementDatatable from "./components/TaskManagementDatatable";

const TaskManagement = () => {
  return (
    <>
      <Sidebar />

      <MainSection>
        <SectionHeader title="Task Management" />
        <DatatableSection>
          <TaskManagementDatatable />
        </DatatableSection>
      </MainSection>
    </>
  );
};

export default TaskManagement;
